import React, { ReactElement, ReactNode } from 'react';
import { Context, Query, QueryResult } from 'react-apollo';
import ApolloClient, { ApolloError, OperationVariables } from 'apollo-client';
import { DocumentNode } from 'apollo-link';

export type ErrorControllerProps<T> = {
  children: ReactNode;
  query: DocumentNode;
  variables: OperationVariables;
  apolloClient?: ApolloClient<unknown>;
  context?: Context;
  handler(loading: boolean, error?: ApolloError, data?: T): ReactElement;
};

function ErrorController<T>({
  children,
  query,
  context,
  variables,
  apolloClient,
  handler,
}: ErrorControllerProps<T>) {
  return (
    <Query
      query={query}
      context={context}
      variables={variables}
      client={apolloClient}
    >
      {({ loading, error, data }: QueryResult<T>) =>
        handler(loading, error, data) || children
      }
    </Query>
  );
}

export default ErrorController;
